import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

import OverallProgress from './overall-progress';
import Regions from './regions';
import Stars from './stars';

const useStyles = createUseStyles({
  trophies: {
    composes: ['flex-rows', 'flex-start', 'is-relative'],
  },
  wrapper: {
    zIndex: 10,
  },
});

const TrophiesViewComponent = React.memo(({ lmap }) => {
  const classes = useStyles();

  return (
    <div className={classes.trophies}>
      <Stars />
      <div className={classes.wrapper}>
        <OverallProgress />
        <Regions lmap={lmap} />
      </div>
    </div>
  );
});

TrophiesViewComponent.propTypes = {
  lmap: PropTypes.shape().isRequired,
};

TrophiesViewComponent.displayName = 'TrophiesViewComponent';

export default TrophiesViewComponent;
